export default __webpack_public_path__ + "static/media/619.7f4d7c68.jpg";